import Router from 'next/router'

import IconAttention from '@/assets/icons/ic_logic-g-app_attention.svg'
import { Button } from '@/components/ui/button'

export const GenericError = (): JSX.Element => {
  const homePage = Router.pathname.match(/^\/web\/?/)?.[0]
    ? '/web/user-setting/'
    : '/app/home/'
  return (
    <div className="flex h-[100vh] flex-col items-center bg-white pt-[150px]">
      <h3 className="mb-[15px] text-2xl font-bold leading-[150%] tracking-widest text-primary-text">
        エラーが発生しました
      </h3>

      <p className="text-[15px] leading-[150%] tracking-widest text-secondary-text">
        ホームに戻って、再度お試しください。
      </p>

      <IconAttention width={104} className="mx-auto mt-[40px]" />

      <Button
        asChild
        variant="default"
        className="shadow-medium mt-[100px] h-[47px] w-[268px] rounded-md text-[17px]"
      >
        {
          // eslint-disable-next-line @next/next/no-html-link-for-pages
          <a href={homePage}>ホームに戻る</a>
        }
      </Button>
    </div>
  )
}
